import React from 'react';
import { Flex } from 'antd';
import HeaderBar from '../components/HeaderBar';

import './BasicLayout.less';

const BasicLayout = ({ children }) => {
	return (
		<div className="basic-layout">
			<HeaderBar />
			<Flex
				vertical
				align="flex-start"
				className="basic-layout-content"
			>
				{children}
			</Flex>
		</div>
	);
};

export default BasicLayout;
